import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const isTorinoCenter = (item) => {
  const title = item?.shopping_center?.title?.toLowerCase() || '';
  const name = item?.shopping_center?.name?.toLowerCase() || '';
  return title.includes('torino') || name.includes('torino');
};

const htmlContent = (html) => {
  if (!html) {
    return '—';
  }
  return (
    <div
      style={{ maxWidth: '100%', wordBreak: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

const imageField = (file) => {
  const url = file?.url;
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <img
        src={url}
        alt={file.file_name || 'image'}
        style={{ maxWidth: 200, maxHeight: 120, objectFit: 'contain' }}
      />
    </a>
  );
};

const linkField = (url) => {
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      {url}
    </a>
  );
};

const buildLanguageFields = (t, item, lang) => {
  const suffix = lang.toLowerCase();
  const title = item[`title_${suffix}`] || (suffix === 'it' ? item.title : '');
  const description = item[`description_${suffix}`];
  const link = item[`link_${suffix}`];

  return [
    { text: `${t('Titolo')} ${lang}`, value: display(title) },
    {
      text: `${t('Descrizione')} ${lang}`,
      value: htmlContent(description),
    },
    { text: `${t('Link')} ${lang}`, value: linkField(link) },
  ];
};

export const getHomepageBlockViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const sections = [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        {
          text: t('Mostra il link'),
          value: item.show_link ? t('Yes') : t('No'),
        },
        { text: t('Immagine'), value: imageField(item.file) },
      ],
    },
    {
      title: `${t('Contenuto')} (IT)`,
      fields: buildLanguageFields(t, item, 'IT'),
    },
    {
      title: `${t('Contenuto')} (EN)`,
      fields: buildLanguageFields(t, item, 'EN'),
    },
  ];

  if (isTorinoCenter(item)) {
    sections.push({
      title: `${t('Contenuto')} (FR)`,
      fields: buildLanguageFields(t, item, 'FR'),
    });
  }

  return sections;
};
